<div fxLayout="column" style="padding:15px;" fxLayoutAlign="center center center">

  <div *ngIf="!columnsLoaded" fxLayout="row" fxFlex="100" fxLayoutAlign="center center center">
    <div fxLayout="column" fxLayoutAlign="center center">
      <app-loading></app-loading>
      <label>Παρακλούμε περιμένετε όσο φορτώνουμε τα δεδομένα</label>
    </div>
  </div>

  <div *ngIf="columnsLoaded" fxLayout="row" ngStyle.gt-lg="width:96%;" ngStyle.lg="width:96%;"
       ngStyle.lt-lg="width:100%;">
    <mat-card>
      <mat-card-title>
        <label>Αναφορές για τη φόρμα {{this.title}}</label>
      </mat-card-title>

      <mat-card-content fxLayout="column" style="position: relative">
        <div fxLayout="row" fxFlex="100" fxLayoutGap="5px" fxLayoutAlign="start center">
          <button mat-icon-button (click)="initViewStoring()" matTooltip="Δημιουργία προτύπου πίνακα">
            <mat-icon class="main-icon">data_saver_on</mat-icon>
          </button>

          <div fxLayout="row" fxLayoutGap="5px" *ngIf="isViewSaving" fxLayoutAlign="start center">
            <mat-form-field>
              <mat-label>Όνομα προτύπου</mat-label>
              <input matInput [(ngModel)]="viewName"/>
            </mat-form-field>
            <button mat-icon-button (click)="submitView()" class="main-icon" matTooltip="Αποθήκευση">
              <mat-icon>save</mat-icon>
            </button>
            <button mat-icon-button (click)="closeViewSaving()" matTooltip="Ακύρωση">
              <mat-icon>close</mat-icon>
            </button>
          </div>
          <button mat-icon-button (click)="loadViews()" class="main-icon" matTooltip="Φόρτωση προτύπων πίνακα">
            <mat-icon>table</mat-icon>
          </button>
        </div>


        <div fxLayout="row" [style.height.px]="internalHeight" style="overflow-y: auto;">
          <dx-data-grid
            #table
            [dataSource]="data"
            [width]="windowWidth"
            style="overflow-x: auto;"
            (onExporting)="onExporting($event)"
            [showBorders]="true"
            [focusedRowEnabled]="true"
            [showColumnLines]="true"
            [showRowLines]="false"
            keyExpr="id"
            [rowAlternationEnabled]="true"
            [allowColumnResizing]="true"
            [columnAutoWidth]="true"
            [allowColumnReordering]="true">
            <dxo-state-storing
              [enabled]="true"
              type="custom"
              [customLoad]="loadState"
              [customSave]="saveState">
            </dxo-state-storing>
            <dxo-export
              [enabled]="true"
              [formats]="['pdf', 'xlsx', 'docx', 'csv']"
            ></dxo-export>
            <dxo-column-chooser [allowSearch]="true" [enabled]="true"
                                [emptyPanelText]="'Σύρτε μια στήλη εδώ για να την αποκρύψετε'"
                                [title]="'Απόκρυψη στηλών'"></dxo-column-chooser>
            <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
            <dxo-filter-row
              [visible]="showFilterRow"
              [applyFilter]="currentFilter"
            ></dxo-filter-row>
            <dxo-header-filter [visible]="showHeaderFilter" [title]="'Επιλογή όλων'" [textContent]="'Επιλογή'"
                               [texts]="{cancel: 'άκυρο', emptyValue: 'Επιλογή όλων'}"></dxo-header-filter>
            <dxo-search-panel
              [visible]="true"
              [width]="240"
              placeholder="Αναζήτηση..."
            ></dxo-search-panel>
            <dxo-grouping
              [contextMenuEnabled]="true">
            </dxo-grouping>
            <dxo-group-panel [emptyPanelText]="'Σύρτε μια στήλη εδώ για να την ομαδοποιήσετε'"
                             [visible]="true"></dxo-group-panel>
            <dxi-column
              [width]="70"
              [alignment]="'left'"
              dataField="id"
              caption="Ενέργειες"
              [allowFiltering]="false"
              [allowSorting]="false"
              [allowExporting]="false"
              [allowGrouping]="false"
              cellTemplate="cellTemplate-report"
            ></dxi-column>
            <dxi-column *ngFor="let column of renderDateColumns()" [title]="column.label"
                        [caption]="displayCaption(column.label)" [dataField]="column.key" [alignment]="'left'"
                        [format]="'dd-MM-yyyy'" [showWhenGrouped]="true" [dataType]="'date'"
                        [visible]="column.displayOnTable"></dxi-column>

            <dxi-column *ngFor="let column of renderNonDateColumns()" [title]="column.label"
                        [caption]="displayCaption(column.label)" [dataField]="column.key" [alignment]="'left'"
                        [showWhenGrouped]="true" [visible]="column.displayOnTable"></dxi-column>


            <dxo-paging [pageSize]="200"></dxo-paging>

            <div *dxTemplate="let data of 'cellTemplate-report'" fxLayout="row" fxLayoutGap="5px">
              <button mat-icon-button class="internal-icons" (click)="navigateToResumeDetails(data)"
                      matTooltip="Προεπισκόπηση">
                <mat-icon>visibility</mat-icon>
              </button>
              <button mat-icon-button class="internal-icons" (click)="downloadPDF(data)"
                      matTooltip="Λήψη pdf">
                <mat-icon>download</mat-icon>
              </button>
            </div>

          </dx-data-grid>
        </div>


        <mat-card *ngIf="views.isDisplaying"
                  cdkDrag fxLayout="column"
                  style="z-index: 10; overflow-y:auto; background-color: white; position: absolute; top:20%; right: 5px; width: 400px; height: 250px;">
          <mat-card-title>
            <div fxLayout="row" fxLayoutAlign="start center" style="cursor: pointer">
              <label fxFlex="100">Εμφανίσεις πίνακα</label>
              <button mat-icon-button (click)="hideViews()">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </mat-card-title>

          <mat-card-content>
            <div fxLayout="column" *ngIf="views.isLoading" style="margin-top: 15px;">
              <div fxLayout="row" fxFlex="100" fxLayoutAlign="center center">
                <app-loading></app-loading>
              </div>
            </div>
            <div fxLayout="column" fxFlex="100" *ngIf="!views.isLoading">
              <div fxLayout="row" fxLayoutGap="5px" fxLayoutAlign="start center"
                   style="padding: 5px; border-bottom: 1px solid lightgray;" *ngFor="let view of views.records">
                <label fxFlex="100">{{view.name}}</label>
                <button *ngIf="view.isDefault" [disabled]="shouldBeDisabled()" mat-icon-button  (click)="setDefault(view)">
                <mat-icon style="color: green">toggle_one</mat-icon>
                </button>
                <button *ngIf="!view.isDefault" [disabled]="shouldBeDisabled()" mat-icon-button
                        (click)="setDefault(view, true)">
                  <mat-icon>toggle_off</mat-icon>
                </button>
                <button [disabled]="shouldBeDisabled()" mat-icon-button (click)="applyView(view)">
                  <mat-icon>check</mat-icon>
                </button>
                <button [class.spinner]="views.isDeleting" [disabled]="shouldBeDisabled()" mat-icon-button
                        (click)="deleteView(view.id)">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
          </mat-card-content>
        </mat-card>

      </mat-card-content>
    </mat-card>

  </div>
</div>
